import newestItemSection from './newestItemSection'

export default newestItemSection
